import React, { useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import GlobalDemoForm from './components/shared/GlobalDemoForm';
import HomePage from './pages/HomePage';
import ReconocimientoPage from './pages/ReconocimientoPage';
import ComunicacionPage from './pages/ComunicacionPage';
import FidelizacionPage from './pages/FidelizacionPage';
import SaludMentalPage from './pages/SaludMentalPage';
import MotiCarePage from './pages/MotiCarePage';
import FitRewardsPage from './pages/FitRewardsPage';
import CasosDeExitoPage from './pages/CasosDeExitoPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactoPage from './pages/ContactoPage';
import ProveedoresPage from './pages/ProveedoresPage';
import FAQPage from './pages/FAQPage';
import PrivacidadPage from './pages/PrivacidadPage';
import PrivacidadFitRewardsPage from './pages/PrivacidadFitRewardsPage';
import BlogAdminPage from './pages/BlogAdminPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppContent() {
  const { currentTheme: t } = useTheme();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div style={{ background: t.bg, minHeight: '100vh' }}>
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reconocimiento-laboral" element={<ReconocimientoPage />} />
          <Route path="/comunicacion-interna" element={<ComunicacionPage />} />
          <Route path="/fidelizacion-de-clientes" element={<FidelizacionPage />} />
          <Route path="/salud-mental" element={<SaludMentalPage />} />
          <Route path="/moticare" element={<MotiCarePage />} />
          <Route path="/fitrewards" element={<FitRewardsPage />} />
          <Route path="/clientes" element={<CasosDeExitoPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          <Route path="/proveedores" element={<ProveedoresPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/politica-de-privacidad" element={<PrivacidadPage />} />
          <Route path="/politica-de-privacidad/fitrewards" element={<PrivacidadFitRewardsPage />} />
          <Route path="/admin/blog" element={<BlogAdminPage />} />
        </Routes>
      </main>
      {!isAdmin && <GlobalDemoForm />}
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppContent />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
